var map = {
	"./kid-Aileen.png": 13287,
	"./kid-Anna.png": 64995,
	"./kid-Annabel.png": 34126,
	"./kid-Barry.png": 9233,
	"./kid-Belle.png": 40593,
	"./kid-Brian.png": 27865,
	"./kid-Brittany.png": 42044,
	"./kid-Bruce.png": 78616,
	"./kid-Bubu.png": 60497,
	"./kid-Candice.png": 24226,
	"./kid-Curt.png": 17519,
	"./kid-Darren.png": 92945,
	"./kid-Dave.png": 85027,
	"./kid-Debby.png": 68095,
	"./kid-Duke.png": 53892,
	"./kid-Duncan.png": 79424,
	"./kid-Edward.png": 89504,
	"./kid-Eileen.png": 25811,
	"./kid-Ellie.png": 92002,
	"./kid-Eric.png": 74892,
	"./kid-Fred.png": 13242,
	"./kid-Gary.png": 25474,
	"./kid-Ginny.png": 30132,
	"./kid-Grace.png": 17269,
	"./kid-Hannah.png": 79807,
	"./kid-Ivy.png": 93255,
	"./kid-James.png": 24997,
	"./kid-Jane.png": 7049,
	"./kid-Josh.png": 88177,
	"./kid-Julia.png": 81642,
	"./kid-Lewis.png": 27021,
	"./kid-Lisa.png": 79380,
	"./kid-Liz.png": 3656,
	"./kid-Maurice.png": 8705,
	"./kid-Meg.png": 49020,
	"./kid-Michael.png": 67306,
	"./kid-Olivia.png": 12803,
	"./kid-Pearce.png": 22433,
	"./kid-Robin.png": 18473,
	"./kid-Rosa.png": 89192,
	"./kid-Roy.png": 74095,
	"./kid-Sally.png": 8292,
	"./kid-Sara.png": 79742,
	"./kid-Stanley.png": 69795,
	"./kid-Steven.png": 16312,
	"./kid-Teddy.png": 48207,
	"./kid-Timothy.png": 31327,
	"./kid-Tommy.png": 96635,
	"./kid-Vicky.png": 7903,
	"./kid-Willy.png": 95344
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 16310;